import ReactMarkdown, { type Components } from 'react-markdown';
import {
  REHYPE_PLUGINS,
  REMARK_PLUGINS,
} from '@/components/core/markdown/markdown';

/**
 * Lesson markdown with the reader's renderers. ReactMarkdown 10 strips
 * unrecognized URL schemes by default, which would erase our `cite://` href
 * before the custom `a` renderer sees it; the identity transform keeps the
 * scheme so citations render via the CitationChip branch.
 */
export function LessonMarkdown({
  children,
  components,
}: {
  children: string;
  components: Components;
}) {
  return (
    <ReactMarkdown
      remarkPlugins={REMARK_PLUGINS}
      rehypePlugins={REHYPE_PLUGINS}
      components={components}
      urlTransform={url => url}
    >
      {children}
    </ReactMarkdown>
  );
}
